var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParagraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1501 4.99956C9.21032 4.98436 8.29375 5.2917 7.55314 5.87036C6.81253 6.44902 6.29262 7.26404 6.08007 8.17956C5.95804 8.76221 5.96759 9.36474 6.10802 9.94322C6.24846 10.5217 6.51624 11.0616 6.89184 11.5234C7.26744 11.9852 7.74139 12.3574 8.27911 12.6128C8.81684 12.8682 9.40478 13.0003 10.0001 12.9996V18.9996H12.0001V6.99956H14.0001V18.9996H16.0001V6.99956H18.0001V4.99956H10.1501ZM8.00007 8.99956C8.00007 8.46913 8.21078 7.96042 8.58586 7.58535C8.96093 7.21028 9.46964 6.99956 10.0001 6.99956V10.9996C9.46964 10.9996 8.96093 10.7888 8.58586 10.4138C8.21078 10.0387 8.00007 9.52999 8.00007 8.99956Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14.5L32 9.5H24L28 14.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraph);
export default __webpack_public_path__ + "static/media/paragraph.eaefc029ac8774927bef3c02b87ec7f1.svg";
export { ForwardRef as ReactComponent };